export default __webpack_public_path__ + "static/media/SSC_2019_StochAlgoPortfolio.01daa294.pdf";